/** Resolve padding without supplying defaults for unspecified sides. */
function resolvePadding(padding) {
    if (padding == null)
        return {};
    if (typeof padding === 'string' || typeof padding === 'number')
        return { padding };
    const { top: paddingTop, bottom: paddingBottom, left: paddingLeft, right: paddingRight } = padding;
    return { paddingTop, paddingBottom, paddingLeft, paddingRight };
}

export { resolvePadding };
//# sourceMappingURL=padding.js.map
